import {
	Model,
	SalesOrder,
	TransactionErrorType
} from ".";

export default class SalesOrderError extends Model {
	get singularNoun() {
		return "sales order error";
	}

	get mutations() {
		return {
			salesOrder: SalesOrder,
			errorTypes: TransactionErrorType
		};
	}

	get salesOrderNumbers() {
		if ( this.salesOrders ) {
			return this.salesOrders.map( so => so.salesOrderNumber ).join( ", " );
		}
	}

	get errorTypeNames() {
		if ( this.errorTypes ) {
			return this.errorTypes.map( type => type.name ).join( ", " );
		}
	}

	resource() {
		return "sales/sales-orders/errors";
	}
}
